(function () {
  'use strict';

  function initProductGallery(gallery) {
    if (!gallery || gallery.dataset.mmgGalleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-mmg-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-mmg-gallery-thumb]'));
    const stage = gallery.querySelector('[data-mmg-gallery-stage]');
    const previous = gallery.querySelector('[data-mmg-gallery-prev]');
    const next = gallery.querySelector('[data-mmg-gallery-next]');
    const current = gallery.querySelector('[data-mmg-gallery-current]');
    const lightbox = gallery.querySelector('[data-mmg-gallery-lightbox]');
    const lightboxImage = gallery.querySelector('[data-mmg-gallery-lightbox-image]');
    const close = gallery.querySelector('[data-mmg-gallery-close]');

    if (!slides.length) return;

    gallery.dataset.mmgGalleryReady = 'true';
    let index = 0;
    let touchStartX = null;
    let touchStartY = null;
    let lightboxOpener = null;
    let scrollLockState = null;

    function render(nextIndex, shouldFocus) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
      });

      if (current) current.textContent = String(index + 1);
      if (previous) previous.disabled = slides.length < 2;
      if (next) next.disabled = slides.length < 2;

      if (shouldFocus && thumbs[index]) thumbs[index].focus({ preventScroll: true });
    }

    function lockPageScroll() {
      if (scrollLockState) return;
      const root = document.documentElement;
      const body = document.body;
      scrollLockState = {
        x: window.scrollX,
        y: window.scrollY,
        rootOverflow: root.style.overflow,
        bodyOverflow: body.style.overflow
      };
      root.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    }

    function unlockPageScroll() {
      if (!scrollLockState) return;
      const root = document.documentElement;
      const body = document.body;
      const state = scrollLockState;
      scrollLockState = null;
      root.style.overflow = state.rootOverflow;
      body.style.overflow = state.bodyOverflow;
      window.scrollTo(state.x, state.y);
    }

    function getLightboxFocusables() {
      if (!lightbox) return [];
      return Array.from(
        lightbox.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element instanceof HTMLElement && !element.hidden);
    }

    function openLightbox(opener) {
      const image = slides[index].querySelector('img');
      if (!lightbox || !lightboxImage || !image) return;
      lightboxOpener = opener instanceof HTMLElement ? opener : document.activeElement;
      lightboxImage.src = image.currentSrc || image.src;
      lightboxImage.alt = image.alt || '';
      lockPageScroll();
      lightbox.hidden = false;
      if (close) close.focus({ preventScroll: true });
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      const returnTarget = lightboxOpener;
      lightboxOpener = null;
      lightbox.hidden = true;
      if (lightboxImage) lightboxImage.removeAttribute('src');
      unlockPageScroll();
      if (returnTarget instanceof HTMLElement && returnTarget.isConnected) {
        returnTarget.focus({ preventScroll: true });
      } else if (stage) {
        stage.focus({ preventScroll: true });
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        render(Number(thumb.dataset.mmgGalleryThumb || 0), false);
      });
    });

    if (previous) previous.addEventListener('click', () => render(index - 1, true));
    if (next) next.addEventListener('click', () => render(index + 1, true));

    gallery.querySelectorAll('[data-mmg-gallery-open]').forEach((button) => {
      button.addEventListener('click', () => {
        render(Number(button.dataset.mmgGalleryIndex || index), false);
        openLightbox(button);
      });
    });

    if (close) close.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      lightbox.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || lightbox.hidden) return;
        const focusables = getLightboxFocusables();
        if (!focusables.length) {
          event.preventDefault();
          if (close) close.focus({ preventScroll: true });
          return;
        }
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    if (stage) {
      stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          render(index - 1, false);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          render(index + 1, false);
        } else if (event.key === 'Home') {
          event.preventDefault();
          render(0, false);
        } else if (event.key === 'End') {
          event.preventDefault();
          render(slides.length - 1, false);
        }
      });

      stage.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      stage.addEventListener('touchend', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch || touchStartX === null || touchStartY === null) return;
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        render(index + (deltaX < 0 ? 1 : -1), false);
      }, { passive: true });
    }

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && lightbox && !lightbox.hidden) {
        event.preventDefault();
        closeLightbox();
      }
    });

    render(0, false);
  }

  function init() {
    document.querySelectorAll('[data-mmg-product-gallery]').forEach(initProductGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();